var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userOrder"},[_c('div',{staticClass:"userOrder-box"},[_c('router-link',{attrs:{"to":_vm.orderlistPath}},[_c('img',{staticClass:"personal-information",attrs:{"src":require("@/assets/image/user/personal_information.png"),"alt":""}}),_c('span',[_vm._v("My order")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }